import React from 'react';
import { FiStar } from 'react-icons/fi';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    const now = new Date();
    const isToday = d.toDateString() === now.toDateString();
    if (isToday) {
      return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    const diffDays = Math.floor((now - d) / 86400000);
    if (diffDays < 7) {
      return d.toLocaleDateString([], { weekday: 'short' });
    }
    return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
  } catch {
    return '';
  }
};

const getInitials = (name = '') => {
  const parts = name.trim().split(' ');
  return parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : (name[0] || '?').toUpperCase();
};

const EmailListItem = ({ message, selected, onClick }) => {
  const { from, subject, snippet, date, isUnread, labelIds = [] } = message;
  const senderName = from?.name || from?.email || 'Unknown';
  const label = labelIds.find((l) =>
    ['webinar', 'partnership', 'feedback', 'vip'].includes(l.toLowerCase())
  );

  return (
    <div
      className={`ec-list-item${selected ? ' selected' : ''}${!isUnread ? ' read' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}
    >
      <div className="ec-list-row1">
        <span className="ec-sender-name">{senderName}</span>
        <div className="ec-item-right">
          {isUnread && <span className="ec-unread-dot" />}
          <span className="ec-item-time">{formatDate(date)}</span>
          <button
            className="ec-star-btn"
            onClick={(e) => e.stopPropagation()}
            aria-label="Star"
          >
            <FiStar size={13} />
          </button>
        </div>
      </div>

      <div className="ec-item-subject">{subject}</div>
      <div className="ec-item-preview">{snippet}</div>

      {label && (
        <div className="ec-item-footer">
          <span className="ec-label-tag">{label.toLowerCase()}</span>
        </div>
      )}
    </div>
  );
};

export default EmailListItem;
